import { TNavigationTreeNode } from '../redux-store';

export const EXCLUDE_SIDEBAR_LINKS = ['/factories/shift-setup'];

export const MOBILE_NODES: TNavigationTreeNode['id'][] = [
  'TNA_UPDATES',
  'APPROVALS',
  'TNA',
  'ANALYTICS',
  'ORDER_CHECKLIST',
];

export const NAVIGATION_TREE_LIST: TNavigationTreeNode[] = [
  {
    id: 'GROUP_HOME',
    title: 'Group Home',
    title_minimizedVersion: 'Group',
    url: ['/'],
    icon: 'assets/icon/sidebar/ic-grp-home.svg',
    icon_minimizedVersion: 'assets/icon/sidebar/ic-grp-home-large.svg',
    featureId: 'FACTORY_LISTING',
    children: [
      {
        id: 'PLANNER_DASHBOARD',
        title: 'Planner Dashboard ',
        url: ['/planner-dashboard'],
        icon: 'assets/icon/sidebar/ic-planner-dashboard.svg',
        icon_minimizedVersion: 'assets/icon/sidebar/ic-planner-dashboard-large.svg',
        featureId: 'VIEW_PLANNER_DASHBOARD',
        children: [],
      },
      {
        id: 'MERCHANDISER_DASHBOARD',
        title: 'Merchandiser Dashboard ',
        url: ['/merchandiser-dashboard'],
        icon: 'assets/icon/sidebar/ic-merchandiser-dashboard.svg',
        icon_minimizedVersion: 'assets/icon/sidebar/ic-merchandiser-dashboard-large.svg',
        featureId: 'VIEW_MERCHANDISER_DASHBOARD',
        children: [],
      },
      {
        id: 'FACTORIES',
        title: 'Factories',
        title_minimizedVersion: 'Factories',
        url: ['/factories'],
        icon: 'assets/icon/sidebar/ic-factory.svg',
        icon_minimizedVersion: 'assets/icon/sidebar/ic-factory-large.svg',
        featureId: 'FACTORY_LISTING',
        children: [],
      },
      {
        id: 'ACCOUNT_CONFIG_SETUP',
        title: 'Config Setup',
        title_minimizedVersion: 'Config',
        url: ['/config-setup'],
        icon: 'assets/icon/sidebar/ic-config.svg',
        icon_minimizedVersion: 'assets/icon/sidebar/ic-config-large.svg',
        featureId: 'ACCOUNT_CONFIG_SETUP',
        children: [],
      },
      {
        id: 'EMPLOYEE_LIST',
        title: 'Employee List',
        title_minimizedVersion: 'Employee',
        url: ['/employee-list'],
        icon: 'assets/icon/sidebar/ic-employee-list.svg',
        icon_minimizedVersion: 'assets/icon/sidebar/ic-employee-list-large.svg',
        featureId: 'EMPLOYEES_LISTING',
        children: [],
      },
      {
        id: 'ORDER_ATTRIBUTES',
        title: 'Order Attributes',
        title_minimizedVersion: 'Order Attributes',
        url: ['/order-attributes'],
        icon: 'assets/icon/sidebar/ic-product-types.svg',
        icon_minimizedVersion: 'assets/icon/sidebar/ic-product-types-large.svg',
        featureId: 'ORDER_ATTRIBUTES_LISTING',
        children: [],
      },
      {
        id: 'LEARNING_CURVE',
        title: 'Learning Curve ',
        url: ['/learning-curve'],
        icon: 'assets/icon/sidebar/ic-learning-curve.svg',
        icon_minimizedVersion: 'assets/icon/sidebar/ic-learning-curve-large.svg',
        featureId: 'LEARNING_CURVES_LISTING',
        children: [],
      },
    ],
  },
  {
    id: 'TNA',
    title: 'TnA',
    url: ['/tna'],
    icon: 'assets/icon/sidebar/ic-tna.svg',
    icon_minimizedVersion: 'assets/icon/sidebar/ic-tna-large.svg',
    featureId: 'TNA_TEMPLATES_LISTING',
    children: [
      {
        id: 'TNA_TEMPLATES',
        title: 'TnA Templates ',
        url: ['/tna/tna-templates'],
        icon: 'assets/icon/sidebar/ic-tna-templates.svg',
        icon_minimizedVersion: 'assets/icon/sidebar/ic-tna-templates-large.svg',
        featureId: 'TNA_TEMPLATES_LISTING',
        children: [],
      },
      {
        id: 'TNA_UPDATES',
        title: 'TnA Updates ',
        url: ['/tna/tna-updates'],
        icon: 'assets/icon/sidebar/ic-tna-updates.svg',
        icon_minimizedVersion: 'assets/icon/sidebar/ic-tna-updates-large.svg',
        featureId: 'TNA_UPDATES_VIEW',
        isMobileScreen: {
          isMobileLandingScreen: true,
          isOnlyMobileScreen: false,
        },
        mobileSidebarConf: {
          icon: 'assets/icon/sidebar/ic-tna-updates.svg',
          text: 'TnA Updates ',
        },
        children: [],
      },
      {
        id: 'APPROVALS',
        title: 'Approvals ',
        url: ['/tna/approvals'],
        icon: 'assets/icon/sidebar/ic-tna-approvals.svg',
        icon_minimizedVersion: 'assets/icon/sidebar/ic-tna-approvals.svg',
        featureId: 'TNA_APPROVALS_VIEW',
        isMobileScreen: {
          isMobileLandingScreen: false,
          isOnlyMobileScreen: true,
        },
        mobileSidebarConf: {
          icon: 'assets/icon/sidebar/ic-tna-approvals.svg',
          text: 'Approvals ',
        },
        children: [],
      },
      {
        id: 'ORDER_CHECKLIST',
        title: 'Checklist',
        url: ['/order-checklist'],
        icon: 'assets/icon/sidebar/checklist-icon.svg',
        icon_minimizedVersion: 'assets/icon/sidebar/checklist-icon.svg',
        featureId: 'READ_WRITE_ORDER_CHECKLIST',
        isMobileScreen: {
          isMobileLandingScreen: false,
          isOnlyMobileScreen: false,
        },
        mobileSidebarConf: {
          icon: 'assets/icon/sidebar/checklist-icon.svg',
          text: 'Checklist ',
        },
        children: [],
      },
      {
        id: 'TNA_BOARD',
        title: 'TnA Board ',
        url: ['/tna/tna-board'],
        icon: 'assets/icon/sidebar/ic-tna-board.svg',
        icon_minimizedVersion: 'assets/icon/sidebar/ic-tna-board-large.svg',
        featureId: 'TNA_BOARD_VIEW',
        children: [],
      },
    ],
  },
  {
    id: 'PROCESS_MAPPING',
    title: 'Process Mapping',
    url: ['/process-mapping'],
    icon: 'assets/icon/sidebar/ic-process-mapping.svg',
    icon_minimizedVersion: 'assets/icon/sidebar/ic-orders-large.svg',
    featureId: 'VIEW_PROCESS_MAP',
    children: [],
  },
  {
    id: 'ORDERS',
    title: 'Orders',
    url: ['/orders'],
    icon: 'assets/icon/sidebar/ic-orders.svg',
    icon_minimizedVersion: 'assets/icon/sidebar/ic-orders-large.svg',
    featureId: 'ORDERS_LISTING_VIEW',
    children: [],
  },
  {
    id: 'PROCESS_BOARDS',
    title: 'Process Boards',
    url: ['/process-boards'],
    icon: 'assets/icon/sidebar/ic-line-level.svg',
    icon_minimizedVersion: 'assets/icon/sidebar/ic-line-level-large.svg',
    featureId: 'PROCESS_BOARD_VIEW',
    children: [],
  },
  {
    id: 'FACTORY_ALLOCATION',
    title: 'Factory Allocation',
    url: ['/factory-allocation'],
    icon: 'assets/icon/sidebar/ic-factory-allocation.svg',
    icon_minimizedVersion: 'assets/icon/sidebar/ic-factory-allocation.svg',
    featureId: 'OPL_LISTING_VIEW',
    children: [],
  },
  {
    id: 'PLANNING-BOARD',
    title: 'Planning Board',
    url: ['/planning-board'],
    icon: 'assets/icon/sidebar/ic-planning-board.svg',
    icon_minimizedVersion: 'assets/icon/sidebar/ic-planning-board-large.svg',
    featureId: 'LL_BOARD_VIEW',
    children: [
      {
        id: 'LINE_LEVEL',
        title: 'Line Level Board',
        url: ['/ll-board'],
        icon: 'assets/icon/sidebar/ic-line-level.svg',
        icon_minimizedVersion: 'assets/icon/sidebar/ic-line-level-large.svg',
        featureId: 'LL_BOARD_VIEW',
        children: [],
      },
      {
        id: 'HL_BOARD',
        title: 'High Level Board',
        url: ['/hl-board'],
        icon: 'assets/icon/sidebar/ic-hl-board.svg',
        icon_minimizedVersion: 'assets/icon/sidebar/ic-hl-board.svg',
        featureId: 'HL_BOARD_VIEW',
        children: [],
      },
    ],
  },
  {
    id: 'OUTPUTS',
    title: 'Outputs',
    url: [],
    icon: 'assets/icon/sidebar/ic-outputs.svg',
    icon_minimizedVersion: 'assets/icon/sidebar/ic-outputs-large.svg',
    featureId: 'ANALYTICS_USER',
    children: [
      {
        id: 'REPORTS',
        title: 'Reports',
        url: ['/reports'],
        icon: 'assets/icon/sidebar/ic-reports.svg',
        icon_minimizedVersion: 'assets/icon/sidebar/ic-reports-large.svg',
        featureId: 'ANALYTICS_USER',
        children: [],
      },
      {
        id: 'ANALYTICS',
        title: 'Analytics',
        url: ['/analytics'],
        icon: 'assets/icon/sidebar/ic-analytics.svg',
        icon_minimizedVersion: 'assets/icon/sidebar/ic-analytics.svg',
        featureId: 'VIEW_OI_APP_DASHBOARD',
        children: [],
        mobileSidebarConf: {
          icon: 'assets/icon/sidebar/ic-analytics.svg',
          text: 'Analytics',
        },
      },
    ],
  },
];
